import React, { useEffect, useState } from 'react';
import { ScreenTitle } from '../../../components';
import './style.scss';
import AuthenticatedRoutes from '../../../routers/authenticated-routes';
import { connect } from 'react-redux';
import { hideWelcomeScreen } from '../../../redux/actions';
import { Link } from 'react-router-dom';
import { INTRO_HEADING, INTRO_INSTRUCTIONS, toolsAndResources_URL } from '../../../shared/constants/Constants';

const WelcomeScreen = ({ hideWelcomeScreen, show_welcome_screen }) => {
  const [screen, set_screen] = useState(1);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return show_welcome_screen ? (
    <div className='welcome-container'>
      <div className='admin-logo'>
        <img
          src={require(`../../../Assets/Images/logo.png`)}
          alt='Prep2Pass'
          className='img-fluid'
        />
      </div>
      {screen === 1 ? (
        <div className='message-wrapper'>
          <div className='welcome-message'>
            <ScreenTitle title={INTRO_HEADING}/>
            {/* <h1>Thank you for using Prep2Pass.</h1> */}
            <ul>
              {INTRO_INSTRUCTIONS.map((inst, ind) => (
                <li key={ind}>{inst}</li>
              ))}
            </ul>
          </div>
          <div className='btn_wrap'>
            <button
              className='blue-btn mt-2'
              type='button'
              onClick={() => set_screen(2)}
            >
              {'Next'}
            </button>
          </div>
        </div>
      ) : screen === 2 ? (
        <div className='welcome-message2'>
          <div className='welcome-button btn-1'>
            <button
              className='blue-btn mt-2'
              type='button'
              onClick={() => {
                set_screen(1);
                hideWelcomeScreen();
              }}
            >
              {'Go to Prep2Pass'}
            </button>
          </div>
          <div className='welcome-button btn-2'>
            <Link
              to={{ pathname: toolsAndResources_URL }}
              target='_blank'
            >
              <button className='blue-btn mt-2' type='button'>
                {'Go to tools and resources'}
              </button>
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <AuthenticatedRoutes/>
  );
};

const mapStateToProps = (state) => {
  return {
    show_welcome_screen: state.CommonReducer.welcomeScreenVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideWelcomeScreen: () => dispatch(hideWelcomeScreen()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeScreen);
